import { Question, Segment } from "hp-types";

const checkKVAFilter = (KVAFilter: boolean, question: Question) => {
  return KVAFilter ? true : question.segment !== Segment.KVA;
};

export default checkKVAFilter;
